/**
 * Numeric input utilities for draft editing and validation.
 *
 * Patterns allow incremental typing (empty string is valid while editing).
 * - DECIMAL_INPUT_PATTERN: digits, optional comma, optional digits
 * - INTEGER_INPUT_PATTERN: digits only
 */
export const DECIMAL_INPUT_PATTERN = /^[0-9]*[,]?[0-9]*$/;
export const INTEGER_INPUT_PATTERN = /^[0-9]*$/;

/**
 * Normalizes draft numeric input by replacing all dots with commas.
 * Keeps user-friendly comma as decimal separator while editing.
 */
export function normalizeNumericDraft(raw: string): string {
  return raw.replace(/\./g, ",");
}
